import Main from "~/js/Main";

export default class ParallaxScrollingElement {

	/**
	 *
	 * @param {HTMLElement} element
	 */
	constructor(element) {
		/**
		 * @type {HTMLElement|null}
		 */
		this.container = element;
		this.currentParallaxOffset = 0;
		this.prevScrollY = 0;

		if (this.container) {
			let ease = this.container.getAttribute("data-ease");
			this.ease = ease !== null ? window.parseFloat(ease) : .5;
			/**
			 * @type {HTMLElement|null}
			 */
			this.waypoint = this.container.closest(".waypoint") || this.container;
			this.offsetTop = this.waypoint?.offsetTop || this.container.offsetTop;
			this.headerEl = Main.Instance.header.getElement();
			/**
			 * @type {HTMLPictureElement}
			 */
			this.pictureEl = this.container.querySelector("picture");
			if (this.pictureEl) {
				this.prevScrollY = this.container.getBoundingClientRect().top;

				window.addEventListener("scroll", Main.Instance.debounce(this.onWindowScroll.bind(this), 10, true), {
					passive: true
				});

				window.addEventListener("resize", Main.Instance.debounce(this.onWindowResize.bind(this)));
				window.addEventListener("load", () => {
					this.adjust();
				});
			}
		}
	}

	adjust() {
		/**
		 * @type {HTMLImageElement}
		 */
		const imgEl = this.pictureEl.querySelector("img");
		if (imgEl) {
			const containerRect = this.container.getBoundingClientRect();
			const imgRect = imgEl.getBoundingClientRect();
			const containerHeight = containerRect.height;
			const imgHeight = imgRect.height;
			const targetScrollHeight = window.innerHeight - containerHeight - this.getHeaderHeightOffset();
			if (imgHeight < containerHeight + targetScrollHeight) {
				const diff = (imgRect.height - containerRect.height);
				this.currentParallaxOffset = -Math.round(diff / 2);
				this.pictureEl.style.height = (containerHeight + targetScrollHeight).toString() + "px";
				this.pictureEl.style.transform = `translateY(${this.currentParallaxOffset}px)`;
			}
			else {
				this.pictureEl.style.height = null;
			}
		}
	}

	update() {
		const containerRect = this.container.getBoundingClientRect();
		const scrollY = containerRect.top - this.getHeaderHeightOffset();
		this.currentParallaxOffset = this.ease * this.prevScrollY * -1;
		this.pictureEl.style.transform = `translateY(${this.currentParallaxOffset}px)`;
		this.prevScrollY = scrollY;
	}

	getHeaderHeightOffset() {
		const computed = window.getComputedStyle(this.headerEl);
		if (computed.position !== "fixed") {
			return this.headerEl.clientHeight;
		}

		return 0;
	}

	/**
	 * @param {Event} e
	 */
	onWindowScroll(e) {
		this.update();
	}
	/**
	 * @param {Event} e
	 */
	onWindowResize(e) {
		this.update();
	}
}
